export const FIELDS = [
    {
        key: 'agencyOwnerNumber',
        name: 'AO/Partnership Number',        
        inputType: 'number'
    },
    {
        key: 'previousAgency',
        name: 'Previous Agency',       
        inputType: 'number'
    }, 
    {
        key: 'currentAgency',
        name: 'Current Agency',        
        inputType: 'number'
    },     
    {
        key: 'priorToAssignDate',
        name: 'Keep Production Prior to Assign Date',       
        inputType: 'dropdown',
        dropDownValues: [{ key: 'yes', value: 'Yes' }, { key: 'no', value: 'No' } ]
    },  
    {
        key: 'startDate',
        name: 'Adjustment Start Date',        
        inputType: 'date'
    },
    {
        key: 'endDate',
        name: 'Adjustment End Date',        
        inputType: 'date'
    },
    {
        key: 'numberofWeeks',
        name: 'Number of Weeks',       
        inputType: 'number'
    },  
    {
        key: 'weeklyNetAdjustment',
        name: 'Weekly Net Submit Adjustment Amount',        
        inputType: 'text'
    },
    {
        key: 'weeklyNetFYAAdjustment',
        name: 'Weekly Net Submit FYA Adjustment Amount',        
        inputType: 'text'
    },      
    {
        key: 'addOrReplace',
        name: 'Add/Remove/Replace',       
        inputType: 'dropdown',
        dropDownValues: [{ key: 'add', value: 'Add' }, { key: 'replace', value: 'Replace' }, { key: 'remove', value: 'Remove' }]
    }
]
